<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { page } from '$app/state';
	interface Props {
		children?: import('svelte').Snippet;
		class?: string;
	}

	let { ...props }: Props = $props();

	// Padding must clear the saved-tags bar, which now renders on every /news
	// page from the first paint rather than waiting on the Cognito round-trip.
	// Keeping this unconditional is what stops the content jumping when auth
	// resolves — previously the bar and this padding both appeared late.
	let showGlobalNav = $derived(page.data.showGlobalNav ?? true);
</script>

<div
	class={twMerge(
		classNames(
			'max-w-full overflow-hidden',
			'bg-gray-100',
			'pt-[6rem] sm:pt-[9.25rem]',
			{
				['lg:pt-[12.875rem]']: showGlobalNav,
				['lg:pt-[6.875rem]']: !showGlobalNav,
			}
		),
		props.class
	)}
>
	{@render props.children?.()}
</div>
